var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"app":"","clipped-left":"","elevation":"1"}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.openDrawerClicked()}}}),_c('v-toolbar-title',[_c('v-img',{attrs:{"width":"120","src":"kmitl_logo.png"}})],1),_c('v-spacer'),_c('LoginButton'),_c('LanguageButton')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }